import { useQuery } from '@tanstack/react-query';

import LineItem from '../types/cart/LineItem';
import { getFileInfo } from '../helpers/validFiles';

const useFileValidation = (lineItem: LineItem, isEnabled: boolean = true) => useQuery({
  queryKey: ['validate-files-line-item', lineItem.id],
  queryFn: () => getFileInfo([lineItem]), // No throw of errors, error === invalid files
  gcTime: 10000,
  enabled: isEnabled, // Only do this API-call when needed
});

export default useFileValidation;
